// import { ConfirmModalController } from '../component/modal/ComfirmModal/ConfirmModalController';
// import { SuccessModalController } from '../component/modal/SuccessModal/SuccessModalController';
// import { SerialModalController } from '../component/modal/SerialModal/SerialModalController';
// import { PdpaContentModalController } from '../component/modal/PdpaContentModal/PdpaContentModalController';
// import { AlertModalController } from '../component/modal/AlertModal/AlertModalController';
import { LoadingModalController } from '../component/modal/LoadingModal/LoadingModalController';

export default function (modalStore) {
    const modalController = modalStore.methods.getModalController()

    const initModal = function () {
        // modalController.setConfirmModal(new ConfirmModalController());
        // modalController.setSuccessModal(new SuccessModalController());
        // modalController.setSerialModal(new SerialModalController());
        // modalController.setPdpaContentModal(new PdpaContentModalController());
        // modalController.setAlertModal(new AlertModalController());
        modalController.setLoadingModal(new LoadingModalController());
    }

    initModal()

    return {
        initModal
    }
}
